import{useEffect as o}from"react";const s=s=>{o(()=>(s&&document.body.classList.add("disableMainScroll"),()=>document.body.classList.remove("disableMainScroll")),[s])};export{s as useScrollDisable};
